import { toast } from "sonner";

export function toastError(message: string) {
    // toast.error(message, {
    //     unstyled: true,
    //     classNames: {
    //         toast: 'bg-red-400',
    //         title: 'text-red-400 text-base',
    //         description: 'text-red-400',
    //         actionButton: 'bg-zinc-400',
    //         cancelButton: 'bg-orange-400',
    //         closeButton: 'bg-lime-400',
    //     }
    // })
    toast.error(message);
}

export function toastSuccess(message: string) {
    toast.success(message);
}